<template>
  <div>
      <Header title="Eureko Sigorta"></Header>
      <slot/>
  </div>
</template>

<script>
import Header from '@/desktop/widget/header'
export default {
  name: 'App',
  components: {
    Header
  },
  mounted () {
    this.eventHub.eventHub.$emit('desktopActive', {
      value: true
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/desktop/template/NoFooter.vue